module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/how-to-enjoy-sola-seasons-pick-022af85bc88552c33ad9797124d5b8cf.jpg";